import { render, staticRenderFns } from "./PointExchangeHistory.vue?vue&type=template&id=d936d6e8&scoped=true&"
import script from "./PointExchangeHistory.vue?vue&type=script&lang=js&"
export * from "./PointExchangeHistory.vue?vue&type=script&lang=js&"
import style0 from "./PointExchangeHistory.vue?vue&type=style&index=0&id=d936d6e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d936d6e8",
  null
  
)

export default component.exports